uniform float starSizeMult;

attribute float scale;
varying vec3 vColor;

void main()
{
    // Position
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPostion = projectionMatrix * viewPosition;
    gl_Position = projectedPostion;

    // Size
    gl_PointSize = starSizeMult * scale;

    // Color
    vColor = color;
}